















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import DimensionType from '@/zenky/interfaces/products/DimensionType';
import Dimension from '@/zenky/interfaces/products/Dimension';

@Component
export default class ProductDimensionsField extends Vue {
  @Prop({ required: true }) readonly value!: any;

  protected watcherEnabled: boolean = false;
  protected dimensions: any[] = [];
  protected available: any[] = [
    { value: Dimension.WEIGHT, label: 'Вес (гр.)' },
    { value: Dimension.WIDTH, label: 'Ширина (мм.)' },
    { value: Dimension.HEIGHT, label: 'Высота (мм.)' },
    { value: Dimension.LENGTH, label: 'Длина (мм.)' },
  ];
  protected types: any[] = [
    { value: DimensionType.NETTO, label: 'Нетто' },
    { value: DimensionType.BRUTTO, label: 'Брутто' },
  ];

  created() {
    this.rebuildLocalDimensions(this.value);

    this.watcherEnabled = true;

    if (!this.dimensions.length) {
      this.addEmptyDimension();
    }
  }

  protected get visibleDimensions() {
    return this.dimensions.filter((dimension: any) => dimension.visible);
  }

  protected rebuildLocalDimensions(value: any) {
    const dimensions: any[] = [];

    if (!Array.isArray(value)) {
      this.dimensions = dimensions;

      return;
    }

    value.forEach((dimension: any) => {
      if (!dimension.name) {
        return;
      }

      dimensions.push({
        id: dimension.id || null,
        visible: true,
        name: dimension.name,
        value: dimension.value || 0,
        type: dimension.type || DimensionType.NETTO,
      });
    });

    this.dimensions = dimensions;
  }

  protected addEmptyDimension() {
    this.dimensions.push({
      id: null,
      visible: true,
      name: Dimension.WEIGHT,
      value: 0,
      type: DimensionType.NETTO,
    });
  }

  protected removeDimensionAt(index: number) {
    if (!this.dimensions[index]) {
      return;
    } else if (!this.dimensions[index].visible) {
      return;
    }

    if (this.dimensions[index].id) {
      this.dimensions[index].visible = false;
      this.dimensions[index].value = 0;
    } else {
      delete this.dimensions[index];
      this.dimensions = this.dimensions.filter((dimension: any) => !!dimension);
    }

    if (!this.visibleDimensions.length) {
      this.addEmptyDimension();
    }
  }

  @Watch('value', { deep: true })
  onValueChange(val: any[]) {
    this.watcherEnabled = false;
    this.rebuildLocalDimensions(val);

    this.$nextTick(() => {
      this.watcherEnabled = true;

      if (!this.visibleDimensions.length) {
        this.addEmptyDimension();
      }
    });
  }

  @Watch('dimensions', { deep: true })
  onDimensonsChange() {
    if (!this.watcherEnabled) {
      return;
    }

    const dimensions = this.dimensions.map((dimension: any) => ({
      name: dimension.name,
      value: dimension.value,
      type: dimension.type,
    }));

    this.$emit('input', dimensions);
  }
}
